import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  ref: "vuecmf_dlg_ref"
};
var _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_full_screen = _resolveComponent("full-screen");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_copy_document = _resolveComponent("copy-document");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    center: _ctx.center,
    modal: _ctx.show_modal,
    "show-close": _ctx.show_close,
    "close-on-press-escape": _ctx.close_on_press_escape,
    "close-on-click-modal": _ctx.close_on_click_modal,
    "custom-class": _ctx.custom_class,
    fullscreen: _ctx.fullscreen,
    draggable: true,
    width: _ctx.width,
    top: _ctx.top,
    "append-to-body": _ctx.append_to_body,
    "model-value": _ctx.dialogVisible,
    onClose: _ctx.close,
    onClosed: _ctx.dlgClosed,
    onOpened: _ctx.opened,
    onOpen: _ctx.open
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("div", {
        innerHTML: _ctx.title,
        class: "vuecmf_dlg_title"
      }, null, 8, _hoisted_2), _createElementVNode("div", {
        class: "min_btn",
        title: "最小化",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.minScreen && _ctx.minScreen.apply(_ctx, arguments);
        })
      }, "—"), _createElementVNode("div", {
        class: "screen_btn",
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        function () {
          return _ctx.toggleScreen && _ctx.toggleScreen.apply(_ctx, arguments);
        })
      }, [_ctx.fullscreen == false ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        title: "最大化"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_full_screen)];
        }),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        title: "还原"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_copy_document)];
        }),
        _: 1
      }))])];
    }),
    footer: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "footer")];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_scrollbar, {
        ref: "scrollbarRef"
      }, {
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "content")];
        }),
        _: 3
      }, 512)];
    }),
    _: 3
  }, 8, ["center", "modal", "show-close", "close-on-press-escape", "close-on-click-modal", "custom-class", "fullscreen", "width", "top", "append-to-body", "model-value", "onClose", "onClosed", "onOpened", "onOpen"])], 512);
}